import Immutable from 'immutable';
import Image from './image';

const CardRecord = Immutable.Record({
  id: 0,
  button: Immutable.Map(),
  type: 'card',
  title: '',
  contents: Immutable.List(),
  viewType: '',
  medium: new Image()
});

class Card extends CardRecord {
  get text() {
    return this.contents.map(tv => tv.get('v')).join();
  }
}

export default Card;



// WEBPACK FOOTER //
// ./src/models/card.js